export const Grain = () => <div className="grain" aria-hidden="true" />;

// Ambient background glows — fixed, behind content
export const Ambient = () => (
  <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden" aria-hidden="true">
    <div className="absolute -top-40 left-1/2 h-[520px] w-[820px] -translate-x-1/2 rounded-full bg-teal-500/10 blur-[140px]" />
    <div className="absolute top-1/3 -left-40 h-[440px] w-[440px] rounded-full bg-teal-600/10 blur-[130px]" />
    <div className="absolute bottom-0 right-0 h-[480px] w-[480px] rounded-full bg-[#0a2a3a]/40 blur-[150px]" />
    <div
      className="absolute inset-0 opacity-[0.4]"
      style={{
        backgroundImage:
          "linear-gradient(rgba(255,255,255,0.025) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.025) 1px, transparent 1px)",
        backgroundSize: "64px 64px",
        maskImage:
          "radial-gradient(ellipse 90% 60% at 50% 0%, black 20%, transparent 75%)",
        WebkitMaskImage:
          "radial-gradient(ellipse 90% 60% at 50% 0%, black 20%, transparent 75%)",
      }}
    />
  </div>
);
